import { ForwardedRef, RefObject } from "react";

import { RefCallBack } from "react-hook-form";

export const mergeRefs = <T>(...refs: (RefObject<T | null> | ForwardedRef<T> | RefCallBack | undefined)[]) => {
  return (node: T) => {
    for (const ref of refs) {
      if (typeof ref === "function") {
        ref(node);
      } else if (ref) {
        ref.current = node;
      }
    }
  };
};
